import React, { useState } from 'react'
import './App.css'

function App() {
  // 狀態管理：inputText 和解析後的資料
  const [inputText, setInputText] = useState('');
  const [parsedData, setParsedData] = useState({});

  // 處理輸入變更的方法
  const handleInputChange = (text) => {
    setInputText(text);
  };

  // 資料解析函數
  const parseTrackingData = (inputData) => {
    // 將輸入資料按逗號分割
    const dataArray = inputData.split(',');
    
    // 定義欄位對應表（根據 CSV 檔案的順序）
    const fieldMapping = [
      // 系統資訊 (0-15)
      { key: 'header', group: 'systemInfo' },
      { key: 'swCode', group: 'systemInfo' },
      { key: 'firmwareVersion', group: 'systemInfo' },
      { key: 'serialNumber', group: 'systemInfo' },
      { key: 'imei', group: 'systemInfo' },
      { key: 'frameSerialNumber', group: 'systemInfo' },
      { key: 'batterySerialNumber', group: 'systemInfo' },
      { key: 'batteryFirmwareVersion', group: 'systemInfo' },
      { key: 'controllerSerialNumber', group: 'systemInfo' },
      { key: 'controllerFirmwareVersion', group: 'systemInfo' },
      { key: 'motorSerialNumber', group: 'systemInfo' },
      { key: 'keySerialNumber', group: 'systemInfo' },
      { key: 'keyFirmwareVersion', group: 'systemInfo' },
      { key: 'isRetransmission', group: 'systemInfo' },
      { key: 'retransmissionDelay', group: 'systemInfo' },
      { key: 'messageType', group: 'systemInfo' },
      
      // 定位資訊 (16-25)
      { key: 'locationType', group: 'locationInfo' },
      { key: 'locationAvailable', group: 'locationInfo' },
      { key: 'locationTime', group: 'locationInfo' },
      { key: 'longitudeWE', group: 'locationInfo' },
      { key: 'longitude', group: 'locationInfo' },
      { key: 'latitudeNS', group: 'locationInfo' },
      { key: 'latitude', group: 'locationInfo' },
      { key: 'altitude', group: 'locationInfo' },
      { key: 'speed', group: 'locationInfo' },
      { key: 'accuracy', group: 'locationInfo' },
      
      // 車輛資訊 (26-37)
      { key: 'totalMileage', group: 'vehicleInfo' },
      { key: 'batteryLevel', group: 'vehicleInfo' },
      { key: 'batteryHealth', group: 'vehicleInfo' },
      { key: 'mainBatteryCharging', group: 'vehicleInfo' },
      { key: 'backupBatteryLevel', group: 'vehicleInfo' },
      { key: 'backupBatteryCharging', group: 'vehicleInfo' },
      { key: 'currentGear', group: 'vehicleInfo' },
      { key: 'currentSpeed', group: 'vehicleInfo' },
      { key: 'currentCadence', group: 'vehicleInfo' },
      { key: 'currentPedalTorque', group: 'vehicleInfo' },
      { key: 'currentControllerTemp', group: 'vehicleInfo' },
      { key: 'currentMotorTemp', group: 'vehicleInfo' },
      
      // 單趟資訊 (38-49)
      { key: 'tripMileage', group: 'tripInfo' },
      { key: 'tripTime', group: 'tripInfo' },
      { key: 'averageSpeed', group: 'tripInfo' },
      { key: 'maxSpeed', group: 'tripInfo' },
      { key: 'averageCadence', group: 'tripInfo' },
      { key: 'maxCadence', group: 'tripInfo' },
      { key: 'averagePedalTorque', group: 'tripInfo' },
      { key: 'maxPedalTorque', group: 'tripInfo' },
      { key: 'averageControllerTemp', group: 'tripInfo' },
      { key: 'maxControllerTemp', group: 'tripInfo' },
      { key: 'averageMotorTemp', group: 'tripInfo' },
      { key: 'maxMotorTemp', group: 'tripInfo' },
      
      // 警報資訊 (50-56)
      { key: 'timeStamp', group: 'alarmInfo' },
      { key: 'alarmField', group: 'alarmInfo' },
      { key: 'errorCode1', group: 'alarmInfo' },
      { key: 'errorCode2', group: 'alarmInfo' },
      { key: 'errorCode3', group: 'alarmInfo' },
      { key: 'errorCode4', group: 'alarmInfo' },
      { key: 'errorCode5', group: 'alarmInfo' }
    ];

    // 初始化解析結果
    const result = {
      systemInfo: {},
      locationInfo: {},
      vehicleInfo: {},
      tripInfo: {},
      alarmInfo: {}
    };

    // 解析每個欄位
    fieldMapping.forEach((field, index) => {
      if (index < dataArray.length) {
        // 取得對應的資料值，如果為空字串則顯示為空
        const value = dataArray[index].trim();
        result[field.group][field.key] = value || '';
      } else {
        // 如果資料不足，設為空值
        result[field.group][field.key] = '';
      }
    });

    return result;
  };

  // 處理提交的方法
  const handleSubmit = () => {
    if (inputText.trim()) {
      try {
        const parsed = parseTrackingData(inputText.trim());
        setParsedData(parsed);
      } catch (error) {
        console.error('解析資料時發生錯誤:', error);
        alert('解析資料時發生錯誤，請檢查輸入格式');
      }
    }
  };

  // GPS 狀態燈邏輯
  const getGpsStatus = () => {
    const locationAvailable = parsedData.locationInfo?.locationAvailable;
    if (!locationAvailable || locationAvailable === '' || locationAvailable === '-') {
      return 'gray';
    }
    return locationAvailable === '0' ? 'red' : 'green';
  };

  // 警報狀態燈邏輯
  const getAlarmStatus = () => {
    const alarmField = parsedData.alarmInfo?.alarmField;
    if (!alarmField || alarmField === '' || alarmField === '-') {
      return 'gray';
    }
    return alarmField === '0' ? 'green' : 'red';
  };

  // 錯誤碼狀態燈邏輯
  const getErrorStatus = () => {
    const errorCode1 = parsedData.alarmInfo?.errorCode1;
    if (!errorCode1 || errorCode1 === '' || errorCode1 === '-') {
      return 'gray';
    }
    return errorCode1 === '0' ? 'green' : 'red';
  };

  // 檢查是否可以開啟地圖
  const canOpenMap = () => {
    return parsedData.locationInfo?.locationAvailable === '1';
  };

  // 將 NMEA 格式座標轉換為十進位格式
  const convertNmeaToDecimal = (nmeaCoord) => {
    const coord = parseFloat(nmeaCoord);
    if (isNaN(coord)) return 0;
    
    // NMEA 格式：DDMM.MMMM 或 DDDMM.MMMM
    // 經度：DDDMM.MMMM (前3位是度，後面是分)
    // 緯度：DDMM.MMMM (前2位是度，後面是分)
    
    let degrees, minutes;
    
    // 判斷是經度還是緯度（經度通常大於9999，緯度小於9999）
    if (coord >= 10000) {
      // 經度格式：DDDMM.MMMM
      degrees = Math.floor(coord / 100);
      minutes = coord - (degrees * 100);
    } else {
      // 緯度格式：DDMM.MMMM
      degrees = Math.floor(coord / 100);
      minutes = coord - (degrees * 100);
    }
    
    // 轉換為十進位：度 + 分/60
    return degrees + (minutes / 60);
  };

  // 開啟 Google Maps
  const openGoogleMaps = () => {
    if (!canOpenMap()) return;
    
    const { longitudeWE, longitude, latitudeNS, latitude } = parsedData.locationInfo;
    
    // 檢查必要的座標資料是否存在
    if (!longitude || !latitude || longitude === '-' || latitude === '-') {
      alert('座標資料不完整，無法開啟地圖');
      return;
    }
    
    // 轉換 NMEA 格式座標為十進位格式
    let lat = convertNmeaToDecimal(latitude);
    let lng = convertNmeaToDecimal(longitude);
    
    // 根據方向調整座標符號
    if (latitudeNS === 'S') lat = -lat;
    if (longitudeWE === 'W') lng = -lng;
    
    // 檢查轉換後的座標是否有效
    if (lat === 0 && lng === 0) {
      alert('座標格式錯誤，無法開啟地圖');
      return;
    }
    
    // 建立 Google Maps URL
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}&z=15&t=m`;
    
    // 開啟新分頁
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>A+ Tracking 資料解析器</h1>
      </header>
      
      <main className="App-main">
        <div className="main-container">
          {/* 左側輸入區域 */}
          <section className="input-section">
            <h2>資料輸入</h2>
            <div className="input-container">
              <textarea
                value={inputText}
                onChange={(e) => handleInputChange(e.target.value)}
                placeholder="請輸入要解析的資料..."
                className="text-input"
                rows="10"
              />
              <button 
                onClick={handleSubmit}
                className="submit-button"
              >
                解析資料
              </button>
            </div>
          </section>

          {/* 右側解析結果區域 */}
          <section className="parse-section">
            <div className="parse-header">
              <h2>解析結果</h2>
              <div className="status-lights">
                <button 
                  className={`map-button ${canOpenMap() ? 'enabled' : 'disabled'}`}
                  onClick={openGoogleMaps}
                  disabled={!canOpenMap()}
                  title={canOpenMap() ? '在 Google Maps 中查看位置' : 'GPS 定位不可用'}
                >
                  地圖
                </button>
                <div className="status-light">
                  <div className={`light ${getGpsStatus()}`}></div>
                  <span>GPS</span>
                </div>
                <div className="status-light">
                  <div className={`light ${getAlarmStatus()}`}></div>
                  <span>警報</span>
                </div>
                <div className="status-light">
                  <div className={`light ${getErrorStatus()}`}></div>
                  <span>錯誤碼</span>
                </div>
              </div>
            </div>
            <div className="parse-container">
              {Object.keys(parsedData).length > 0 ? (
                <div className="parsed-data">
                  {/* 系統資訊 */}
                  <div className="data-group">
                    <h3>系統資訊</h3>
                    <div className="data-fields">
                      <div className="field-row">
                        <span className="field-label">Header:</span>
                        <span className="field-value">{parsedData.systemInfo?.header || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">SW-Code:</span>
                        <span className="field-value">{parsedData.systemInfo?.swCode || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">韌體版本:</span>
                        <span className="field-value">{parsedData.systemInfo?.firmwareVersion || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">序號:</span>
                        <span className="field-value">{parsedData.systemInfo?.serialNumber || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">IMEI:</span>
                        <span className="field-value">{parsedData.systemInfo?.imei || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">車架序號:</span>
                        <span className="field-value">{parsedData.systemInfo?.frameSerialNumber || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">電池序號:</span>
                        <span className="field-value">{parsedData.systemInfo?.batterySerialNumber || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">電池韌體版本:</span>
                        <span className="field-value">{parsedData.systemInfo?.batteryFirmwareVersion || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">控制器序號:</span>
                        <span className="field-value">{parsedData.systemInfo?.controllerSerialNumber || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">控制器韌體版本:</span>
                        <span className="field-value">{parsedData.systemInfo?.controllerFirmwareVersion || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">馬達序號:</span>
                        <span className="field-value">{parsedData.systemInfo?.motorSerialNumber || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">按鍵序號:</span>
                        <span className="field-value">{parsedData.systemInfo?.keySerialNumber || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">按鍵韌體版本:</span>
                        <span className="field-value">{parsedData.systemInfo?.keyFirmwareVersion || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">是否補傳:</span>
                        <span className="field-value">{parsedData.systemInfo?.isRetransmission || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">補傳延後時間 (秒):</span>
                        <span className="field-value">{parsedData.systemInfo?.retransmissionDelay || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">訊息類型:</span>
                        <span className="field-value">{parsedData.systemInfo?.messageType || '-'}</span>
                      </div>
                    </div>
                  </div>

                  {/* 定位資訊 */}
                  <div className="data-group">
                    <h3>定位資訊</h3>
                    <div className="data-fields">
                      <div className="field-row">
                        <span className="field-label">定位類型:</span>
                        <span className="field-value">{parsedData.locationInfo?.locationType || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">定位可用:</span>
                        <span className="field-value">{parsedData.locationInfo?.locationAvailable || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">定位時間:</span>
                        <span className="field-value">{parsedData.locationInfo?.locationTime || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">經度方向:</span>
                        <span className="field-value">{parsedData.locationInfo?.longitudeWE || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">經度:</span>
                        <span className="field-value">{parsedData.locationInfo?.longitude || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">緯度方向:</span>
                        <span className="field-value">{parsedData.locationInfo?.latitudeNS || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">緯度:</span>
                        <span className="field-value">{parsedData.locationInfo?.latitude || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">高度 (m):</span>
                        <span className="field-value">{parsedData.locationInfo?.altitude || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">速度 (m):</span>
                        <span className="field-value">{parsedData.locationInfo?.speed || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">精度 (m):</span>
                        <span className="field-value">{parsedData.locationInfo?.accuracy || '-'}</span>
                      </div>
                    </div>
                  </div>

                  {/* 車輛資訊 */}
                  <div className="data-group">
                    <h3>車輛資訊</h3>
                    <div className="data-fields">
                      <div className="field-row">
                        <span className="field-label">總里程 (m):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.totalMileage || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">電池電量 (%):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.batteryLevel || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">電池健康度 (%):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.batteryHealth || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">主電池充電中:</span>
                        <span className="field-value">{parsedData.vehicleInfo?.mainBatteryCharging || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">備用電池電量 (%):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.backupBatteryLevel || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">備用電池充電中:</span>
                        <span className="field-value">{parsedData.vehicleInfo?.backupBatteryCharging || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">目前檔位:</span>
                        <span className="field-value">{parsedData.vehicleInfo?.currentGear || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">即時速度 (km/h):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.currentSpeed || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">即時踏頻 (rpm):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.currentCadence || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">即時踩踏扭力 (Nm):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.currentPedalTorque || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">即時控制器溫度 (°C):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.currentControllerTemp || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">即時馬達溫度 (°C):</span>
                        <span className="field-value">{parsedData.vehicleInfo?.currentMotorTemp || '-'}</span>
                      </div>
                    </div>
                  </div>

                  {/* 單趟資訊 */}
                  <div className="data-group">
                    <h3>單趟資訊</h3>
                    <div className="data-fields">
                      <div className="field-row">
                        <span className="field-label">單趟里程 (m):</span>
                        <span className="field-value">{parsedData.tripInfo?.tripMileage || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">單趟時間:</span>
                        <span className="field-value">{parsedData.tripInfo?.tripTime || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">平均速度 (km/h):</span>
                        <span className="field-value">{parsedData.tripInfo?.averageSpeed || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">最高速度 (km/h):</span>
                        <span className="field-value">{parsedData.tripInfo?.maxSpeed || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">平均踏頻 (rpm):</span>
                        <span className="field-value">{parsedData.tripInfo?.averageCadence || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">最高踏頻 (rpm):</span>
                        <span className="field-value">{parsedData.tripInfo?.maxCadence || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">平均踩踏扭力 (Nm):</span>
                        <span className="field-value">{parsedData.tripInfo?.averagePedalTorque || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">最大踩踏扭力 (Nm):</span>
                        <span className="field-value">{parsedData.tripInfo?.maxPedalTorque || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">平均控制器溫度 (°C):</span>
                        <span className="field-value">{parsedData.tripInfo?.averageControllerTemp || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">最大控制器溫度 (°C):</span>
                        <span className="field-value">{parsedData.tripInfo?.maxControllerTemp || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">平均馬達溫度 (°C):</span>
                        <span className="field-value">{parsedData.tripInfo?.averageMotorTemp || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">最大馬達溫度 (°C):</span>
                        <span className="field-value">{parsedData.tripInfo?.maxMotorTemp || '-'}</span>
                      </div>
                    </div>
                  </div>

                  {/* 警報資訊 */}
                  <div className="data-group">
                    <h3>警報資訊</h3>
                    <div className="data-fields">
                      <div className="field-row">
                        <span className="field-label">時間戳記:</span>
                        <span className="field-value">{parsedData.alarmInfo?.timeStamp || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">警報欄位:</span>
                        <span className="field-value">{parsedData.alarmInfo?.alarmField || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">錯誤碼-1:</span>
                        <span className="field-value">{parsedData.alarmInfo?.errorCode1 || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">錯誤碼-2:</span>
                        <span className="field-value">{parsedData.alarmInfo?.errorCode2 || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">錯誤碼-3:</span>
                        <span className="field-value">{parsedData.alarmInfo?.errorCode3 || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">錯誤碼-4:</span>
                        <span className="field-value">{parsedData.alarmInfo?.errorCode4 || '-'}</span>
                      </div>
                      <div className="field-row">
                        <span className="field-label">錯誤碼-5:</span>
                        <span className="field-value">{parsedData.alarmInfo?.errorCode5 || '-'}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <p className="empty-state">請輸入資料並點擊解析按鈕</p>
              )}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}

export default App
